<template>
  <b-modal
    id="formPreview"
    headerClass="p-2 mt-2 border-bottom-0"
    footerClass="p-2 border-top-0"
    body-class="pt-0 text-secondary"
    centered
    @ok="$emit('save', 'saveSubmit')"
    @cancel="$bvModal.hide('formPreview')"
    @hide="$bvModal.hide('formPreview')"
  >
    <p>
      If you have questions about this submission, contact
      <a href="mailto:GCSTEmpExcursionSupport@pfizer.com">GCSTEmpExcursionSupport@pfizer.com</a> and
      include your Protocol # and Site #
    </p>
    <p>You are submitting this {{ eventName }} Excursion for the following:</p>
    <p>
      Study ID: {{ studyId }}<br />
      Site ID: {{ siteId }}
    </p>
    <template #modal-header="{ hide }">
      <p class="modal-header-text font-weight-bold pb-0 mb-0 pl-1">
        Submission preview!
      </p>
      <b-button variant="link-dark" class="float-right" @click="hide()"
        ><b-icon icon="x"></b-icon
      ></b-button>
    </template>
    <template #modal-footer="{ cancel,ok }">
      <b-button pill variant="outline-primary" @click="cancel()">
        Continue editing
      </b-button>
      <b-button pill variant="primary" @click="ok()">
        Submit
      </b-button>
    </template>
  </b-modal>
</template>
<script>
  export default {
    props: ['siteId', 'studyId', 'eventName'],
  };
</script>
